/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function($) {
	/*
	 * Dependencies:
	 * TerrificJs 2.0.1,
	 * jQuery 1.7 or greater,
	 * jquery.placeholder.min.js,
	 *
	 */

	'use strict';
	/*globals Tc */
	/*jshint smarttabs:true */

	Tc.Module.TabNavigationSharedContent = Tc.Module.extend({

		on: function(callback) {
			var mod = this;
			mod.tabContent = mod.$ctx.closest('.modTabNavigationContent');
			mod.onStartSubscription();
			callback();
		},

		onStartSubscription: function() {
			var mod = this,
				initialChannel = 'TabNavigation';
			mod.sandbox.subscribe(initialChannel, mod);
			mod.fire('subscribe', {
				element: mod.$ctx,
				subscribe: function(channel, name) {
					mod.navigationChannel = channel;
					mod.name = name;
					mod.sandbox.unsubscribe(initialChannel, mod);
					mod.sandbox.subscribe(channel, mod);
					mod.Registry.add(name, mod.$ctx.children('.shared-content'));
				}
			}, [initialChannel]);
		},

		onVisibleContentChanged: function(data) {
			var mod = this;
			if (mod.tabContent.is(data.content)) {
				// only move shared tab content if we received
				// the event from an active or visible component
				if (mod.$ctx.is('.active') || mod.$ctx.is(':visible')) {
					// do not move the content in edit mode
					// breaks if inside a reference component
					if (!$('body').hasClass('cq_isEditMode')) {
						mod.insertContent();
					}
				}
			}
		},

		insertContent: function() {
			var mod = this, i,
				sharedContents = mod.Registry.get(mod.name);
			if (!mod.$ctx.hasClass('disabled')) {
				for (i = 0; i < sharedContents.length; i++) {
					mod.$ctx.append(sharedContents[i].detach());
				}
			}
		},

		// Singleton object that is shared with all the shared tab content modules on the page
		Registry: {
			contents: [],

			add: function(name, content) {
				if (!this.contents[name]) {
					this.contents[name] = [];
				}
				this.contents[name].push(content);
			},

			get: function(name) {
				if (this.contents[name]) {
					return this.contents[name];
				}
				return [];
			}
		}
	});

}(Tc.$));
}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.TabNavigationSharedContent.js
// module id = 191
// module chunks = 0